export default "__VITE_ASSET__B3dgbWQB__"